<style scoped="scoped" lang="scss">
/deep/.el-dialog .el-dialog__body {
  //max-height: calc(86vh - 112px);
  padding: 0 0 40px 68px;
}
.production-details {
  .panel {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-wrap: nowrap;
    background: #f7f8fa;
    color: #909399;
    height: 28px;
    line-height: 28px;
    // min-width: 1000px;
    width: 100%;
    flex-shrink: 0;

    // 效率信息说明
    .info {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      flex-wrap: nowrap;
      background: #f7f8fa;
      color: #909399;
      height: 28px;
      line-height: 28px;
      // min-width: 1000px;
      width: 100%;
      flex-shrink: 0;

      .info-item-1 {
        max-width: 300px;
        min-width: 280px;
        height: 28px;
        flex-shrink: 0;
      }

      .info-item-2 {
        max-width: 280px;
        height: 28px;
        flex-shrink: 0;
      }

      .info-item-3 {
        width: 100%;
        text-align: right;
        color: #419fff;
      }
    }
  }

  // 效率表单
  .form {
    margin-top: 12px;

    // 标记点
    .percent-box {
      margin-top: 8px;
      display: flex;
      flex-wrap: nowrap;
      align-items: center;
      min-width: 1000px;
      flex-wrap: wrap;

      .percent-input {
        display: flex;
        flex-wrap: nowrap;
        align-items: center;
      }

      .percent-input1 {
        display: flex;
        flex-wrap: nowrap;
        align-items: center;
        margin-left: 35px;
      }

      .border {
        // border: 1px solid #E5E5E5;
        width: 60px;
        height: 28px;
        border-radius: 5px;
        margin-left: 12px;
        text-align: center;
      }

      .mark {
        font-family: Microsoft YaHei UI;
        font-size: 14px;
        color: #606266;
      }

      .border:focus {
        outline: none;
        border: 1px solid rgb(65, 159, 255);
      }

      .text-word {
        font-family: Microsoft YaHei UI;
        font-size: 14px;
        color: #606266;
        margin-left: 26px;
      }

      .percent {
        display: flex;
        flex-wrap: nowrap;
        color: #4d4d4d;
        margin-left: 12px;
      }
    }
  }

  // 详细指标
  .detail-target {
    margin-top: 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    // 左侧
    .left {
      display: flex;
      align-items: center;

      .icon {
        display: inline-block;
        width: 5px;
        height: 16px;
        background: #419fff;
      }

      .txt {
        display: inline-block;
        font-weight: 400;
        font-size: 16px;
        color: #303133;
        margin-left: 12px;
      }
    }

    // 右侧
    .right {
      display: flex;
      align-items: center;
    }
  }

  // 图表和表格
  .echart-table {
    margin-top: 8px;
    margin-bottom: 119px;
  }
}
</style>
<style lang="scss">
.el-transfer-panel__item.el-checkbox {
  margin-right: 0;
}
</style>
<template>
  <div class="production-details">
    <!-- 信息说明 -->
<!--    <div class="panel">
      <div class="info">
        <div class="info-item-1"></div>
        <div class="info-item-2"></div>
        <div class="info-item-3">
          {{ $t("meiri11:00gengxinzuorishuju") }}
        </div>
      </div>
    </div>-->
    <!-- 表单 -->
    <div class="form">
      <div ref="search1">
        <el-form :model="productDetails.searchForm" :inline="true" size="mini">
          <el-form-item :label="$t('shengchangongdanhao')">
            <el-input v-model="productDetails.searchForm.woNo"></el-input>
          </el-form-item>
          <el-form-item :label="$t('ERPgongdanhao')">
            <el-input v-model="productDetails.searchForm.erpNo"></el-input>
          </el-form-item>
          <el-form-item :label="$t('shebeimingcheng')">
            <yi_data_select :multiple="true" :type="'equipment'" :ids.sync="productDetails.searchForm.equipmentId"> </yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('mujumingcheng')">
            <yi_cross_select multiple :component="'web_base_mould_list'" :ids.sync="productDetails.searchForm.mouldId"> </yi_cross_select>
          </el-form-item>
          <el-form-item :label="$t('chanpinmingcheng')" size="mini">
            <yi_data_select :multiple="true" :type="'material2'" :ids.sync="productDetails.searchForm.materialId"> </yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('tibaoshijian')">
            <yi_time_input :maxTime="91 * 24 * 3600 * 1000" type="datetimerange" :start.sync="productDetails.searchForm.createTimeStart" :end.sync="productDetails.searchForm.createTimeEnd"> </yi_time_input>
          </el-form-item>
          <el-form-item :label="$t('caozuoren')">
            <el-input v-model="productDetails.searchForm.nickname"></el-input>
          </el-form-item>
          <el-form-item :label="$t('shifoubulu')">
            <el-select v-model="productDetails.searchForm.type">
              <el-option :label="$t('shi')" :value="1"></el-option>
              <el-option :label="$t('fou')" :value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('baogongriqi')">
            <yi_time_input :maxTime="91 * 24 * 3600 * 1000" type="daterange" format="yyyy-MM-dd" :start.sync="productDetails.searchForm.reportDateStart" :end.sync="productDetails.searchForm.reportDateEnd"> </yi_time_input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="getDetails2" plain>{{ $t("sousuo") }} </el-button>
            <el-button type="default" @click="reset" plain style="margin-left: 10px;">
              {{ $t("chongzhi") }}
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="detail-target">
      <div class="left">
        <span class="icon"></span>
        <span class="txt">{{ $t("chanliangmingxi") }}</span>
      </div>
      <div class="right">
        <!-- 产量明细导出 -->
        <el-button size="mini" style="margin-right:1px" icon="yicon yicon-export" :loading="exportLoading" :title="$t('daochu')" @click="exportproductDetailsExcel()"> </el-button>
        <el-button size="mini" type="default" @click="showShowTableColumn('productDetails')">
          <i class="yicon yicon-config_column"></i>
        </el-button>
      </div>
    </div>
    <!-- 产量明细表格 -->
    <div class="echart-table">
      <div class="table">
        <el-table stripe max-height="1000" :fit="false" :data="productDetails.tableData" :row-style="rowStyle" :cell-style="cellStyle" size="mini" border style="width: 100%" v-loading="searchLoading" :header-cell-style="{ background: '#F5F7FA', color: '#606266', 'font-weight': '700', height: '48px', padding: '0px' }" @header-dragend="headerDragend" @sort-change="sortChange">
          <el-table-column v-for="(item, index) in detailsColumn" :key="index" :prop="item.prop" :sortable="item.sortable" :label="$t(item.label)" :width="item.width" :sort-method="(a, b) => sortMethod(a, b, item)" :show-overflow-tooltip="true"> </el-table-column>
        </el-table>
        <!-- 分页 -->
        <div style="float: right; margin-top:8px">
          <el-pagination class="fy" layout="total, prev, pager, next,sizes" :current-page="productDetails.currentPage" @current-change="handleChange" @size-change="handleSizeChange" @prev-click="handleChange" @next-click="handleChange" :page-sizes="[10, 20, 100, 500]" :total="parseInt(productDetails.total)" :pagerCount="5" background> </el-pagination>
        </div>
      </div>
    </div>
    <div>
      <el-dialog :title="$t(showTableColumn.title)" :visible.sync="showTableColumn.dialog" width="720px">
        <template v-if="showTableColumn.type === 'productDetails'">
          <el-transfer
            ref="transfer"
            :titles="[$t('yincanglie'), $t('xianshilie')]"
            v-model="showTableColumn.productDetails.show"
            :format="{
              noChecked: '${total}',
              hasChecked: '${total}',
            }"
            :data="productDetails.tableColumn"
            @change="showColumnsChange"
          >
            <div slot-scope="{ option }" style="display: flex;justify-content: space-between;width: 100%;" @dragstart="drag($event, option)">
              <div>{{ $t(option.label) }}</div>
              <div>
                <!-- <i @click="columnUp($event,option.label)" class="el-icon-bottom" style="font-size: 14px;"></i> -->
              </div>
            </div>
            <!--           <span slot-scope="{ option }"> {{ $t(option.label) }}</span>-->
          </el-transfer>
        </template>
      </el-dialog>
    </div>
  </div>
</template>
<script type="text/javascript">
import Sortable from "sortablejs";
const date = new Date();
const year = date.getFullYear();
const month = date.getMonth() + 1 > 9 ? date.getMonth() + 1 : "0" + (date.getMonth() + 1);
const current = year + "-" + month;

const startTime = date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + "01";
const endTime = date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();
export default {
  name: "web_report_mes_producee_report_production_details",
  components: {},
  data() {
    return {
      searchLoading: false,
      exportLoading: false,
      show: true,
      activeName: "four",
      fildIds: "",
      aaa: true,
      draggingKey: "",
      timer: null,
      // 产量明细
      productDetails: {
        searchForm: {
          // equipmentId: [],
          // orgId: [],
          // // summaryDate: [startTime, endTime]
          // startTime: (new Date(startTime)).getTime(),
          // endTime: (new Date(date.getFullYear(), date.getMonth(), date.getDate(), 23, 59, 59)).getTime(),
        },
        tableData: [],
        tableColumn: [
          {
            key: 0,
            prop: "woNo",
            sortable: true,
            label: "shengchangongdanhao",
            width: 120,
          },
          {
            key: 1,
            prop: "erpNo",
            sortable: true,
            label: "ERPgongdanhao",
            width: 130,
          },
          {
            key: 2,
            prop: "equipmentName",
            sortable: true,
            label: "shebeimingcheng",
            width: 100,
          },
          {
            key: 3,
            prop: "mouldNo",
            sortable: true,
            label: "mujubianhao",
            width: 100,
          },
          {
            key: 4,
            prop: "mouldName",
            sortable: true,
            label: "mujumingcheng",
            width: 100,
          },
          {
            key: 5,
            prop: "materialCode",
            sortable: true,
            label: "chanpinbianma",
            width: 100,
          },
          {
            key: 6,
            prop: "materialName",
            sortable: true,
            label: "chanpinmingcheng",
            width: 100,
          },
          {
            key: 7,
            prop: "woProcedureNo",
            sortable: true,
            label: "gongxugongdan",
            width: 100,
          },
          {
            key: 8,
            prop: "procedureDesc",
            sortable: true,
            label: "gongxumiaoshu",
            width: 100,
          },
          {
            key: 9,
            prop: "quantity",
            sortable: true,
            label: "baogongshuliang",
            width: 100,
          },
          {
            key: 10,
            prop: "badQuantity",
            sortable: true,
            label: "buliangshuliang",
            width: 100,
          },
          {
            key: 11,
            prop: "machineQuantity",
            sortable: true,
            label: "jiqijilushuliang",
            width: 130,
          },
          {
            key: 12,
            prop: "diffQuantity",
            sortable: true,
            label: "chayishuliang",
            width: 100,
          },
          {
            key: 13,
            prop: "reportDate",
            sortable: true,
            label: "baogongriqi",
            width: 100,
          },
          {
            key: 14,
            prop: "shiftName",
            sortable: true,
            label: "baogongbanci",
            width: 100,
          },
          {
            key: 15,
            prop: "createTime",
            sortable: true,
            label: "tibaoshijian",
            width: 100,
          },
          {
            key: 16,
            prop: "startTime",
            sortable: true,
            label: "jiqijilukaishishijian",
            width: 150,
          },
          {
            key: 17,
            prop: "endTime",
            sortable: true,
            label: "jiqijilujieshushijian",
            width: 150,
          },
          {
            key: 18,
            label: "cavity",
            prop: "cavity",
            width: 150,
          },
          {
            key: 18,
            label: "zongmuqiangshu",
            prop: "totalCavity",
            width: 150,
          },
          {
            key: 19,
            label: "standardCycle",
            prop: "standardCycle",
            width: 150,
          },
          {
            key: 20,
            label: "pingjunzhouqi(miao/mu)",
            prop: "cycle",
            width: 150,
          },
          {
            key: 21,
            prop: "nickname",
            sortable: true,
            label: "caozuoren",
            width: 100,
          },
          {
            key: 22,
            prop: "collaborator",
            sortable: true,
            label: "xiezuoren",
            width: 100,
          },
          {
            key: 23,
            prop: "type",
            sortable: true,
            label: "shifoubulu",
            width: 100,
          },
          {
            key: 24,
            prop: "remark",
            sortable: true,
            label: "beizhu",
            width: 100,
          },
        ],
        total: 0,
        currentPage: 1,
        pageSize: 10,
      },
      // 显示项
      showTableColumn: {
        dialog: false,
        title: "peizhixianshilie",
        type: "equipmentProduction",
        // 产量明细
        productDetails: {
          show: [],
          initShow: [],
        },
      },
    };
  },
  mounted() {
    this.utils.event_hub.$on("MES_EFFICENCY_REPORT_RESIZE", () => {
      setTimeout(() => {
        this.getDetails();
      }, 300);
    });
  },
  computed: {
    detailsColumn() {
      let tableColumn = [];
      for (let i = 0; i < this.productDetails.tableColumn.length; i++) {
        if (this.showTableColumn.productDetails.show.includes(this.productDetails.tableColumn[i]["key"])) {
          tableColumn.push(this.productDetails.tableColumn[i]);
        }
      }
      // production_details
      const name = "mes_production_details_four";
      let colwidths = {};
      if (window.localStorage.getItem("colwidth_" + name)) {
        try {
          colwidths = JSON.parse(window.localStorage.getItem("colwidth_" + name));
        } catch (e) {
          window.localStorage.removeItem("colwidth_" + name);
        }
      }
      if (tableColumn.length > 0) {
        for (const i in tableColumn) {
          if (colwidths[this.$t(tableColumn[i]["label"])] !== undefined) {
            console.log("hhhhhhhvvv", this.$set(tableColumn[i], "colwidth_", colwidths[this.$t(tableColumn[i]["label"])]));
            this.$set(tableColumn[i], "colwidth_", colwidths[this.$t(tableColumn[i]["label"])]);
          }
        }
      }
      return tableColumn;
    },
  },
  created() {
    this.$set(this.productDetails.searchForm, 'reportDateStart', this.begin());
    this.$set(this.productDetails.searchForm, 'reportDateEnd', this.end());
    const name = "mes_production_details_" + this.activeName;
    if (window.localStorage.getItem("colwidth_" + name)) {
      try {
        this.detailsColumn = JSON.parse(window.localStorage.getItem("colwidth_" + name));
      } catch (e) {
        window.localStorage.removeItem("colwidth_" + name);
        this.detailsColumn = this.columns.map((item) => {
          return item.label;
        });
      }
    } else {
      this.detailsColumn = this.columns.map((item) => {
        return item.label;
      });
    }
    if (window.localStorage.getItem("sort_" + name)) {
      let sort_str = window.localStorage.getItem("sort_" + name);
      let sort_arr = JSON.parse(sort_str);
      this.sortChange({
        prop: sort_arr[0],
        order: sort_arr[1],
      });
    }
    setTimeout(() => {
      this.getDetails();
    }, 300);
  },
  destroyed() {
    clearTimeout(this.timer);
  },
  methods: {
    begin() {
      const date = new Date()
      const begin = (new Date(date.getFullYear(), date.getMonth(), 1, 0, 0, 0)).getTime()
      return begin
    },
    end() {
      const date = new Date()
      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      const lastDay = new Date(year, month, 0).getDate();
      const end = (new Date(year, month - 1, lastDay, 23, 59, 59)).getTime()
      return end
    },
    sortMethod(a, b, col) {
      // console.log('ffffffffffffffffffcol',col)
      return (a, b) => {
        let aValue = this.utils.getObjValueByLevelString(a, col.prop);
        let bValue = this.utils.getObjValueByLevelString(b, col.prop);
        if (col.sort == "number") {
          return aValue - bValue;
        } else if (col.sort == "datetime") {
          let reg1 = new RegExp(" ", "g");
          let reg2 = new RegExp("-", "g");
          let reg3 = new RegExp(":", "g");
          return (
            aValue
              .replace(reg1, "")
              .replace(reg2, "")
              .replace(reg3, "") -
            bValue
              .replace(reg1, "")
              .replace(reg2, "")
              .replace(reg3, "")
          );
        } else {
          return (aValue + "").localeCompare(bValue + "") > 0 ? -1 : 1;
        }
      };
    },
    drag(ev, option) {
      this.draggingKey = option.key;
    },
    initColumnsTransfer() {
      console.log("nnnnnnnc", this.detailsColumn);
      const transfer = this.$refs.transfer.$el;
      const leftPanel = transfer.getElementsByClassName("el-transfer-panel")[0].getElementsByClassName("el-transfer-panel__body")[0];
      const rightPanel = transfer.getElementsByClassName("el-transfer-panel")[1].getElementsByClassName("el-transfer-panel__body")[0];
      const rightEl = rightPanel.getElementsByClassName("el-transfer-panel__list")[0];
      Sortable.create(rightEl, {
        animation: 100,
        onEnd: (evt) => {
          const { oldIndex, newIndex } = evt;
          const temp = this.detailsColumn[oldIndex];
          if (!temp || temp === "undefined") {
            return;
          } // 解决右边最后一项从右边拖左边，有undefined的问题
          //这里和网上的有点不一样,网上搜到的结果排序是,当前拖拽的元素和拖拽位置的元素互换位置,但是实际上在使用el-transfer有两个问题
          //1.右侧排序value的数组顺序来源于后台穿的数组顺序,实际如果不设置target-order="unshift"的话,展示会按照左侧的数据列顺序展示,导致拖拽排序时顺序乱七八糟
          //2.实际拖拽排序看到的效果是当前拖拽元素拖拽到其他地方,其他地方的元素会下移,而不是调换顺序
          // 去除空字符串
          for (var i = 0; i < this.detailsColumn.length; i++) {
            if (this.detailsColumn[i] === "" || this.detailsColumn[i] === null || typeof this.detailsColumn[i] === "undefined") {
              this.detailsColumn.splice(i, 1);
              i = i - 1;
            }
          }
          const arr_temp = [].concat(this.detailsColumn); // 创建一个新的临时数组，用以操作后不变更原数组
          arr_temp.splice(newIndex, 0, arr_temp.splice(oldIndex, 1)[0]); // 在b位置插入从a位置截取的元素
          this.detailsColumn = arr_temp;
          console.log(this.detailsColumn);

          //保存
          this.showColumnsChange();
        },
      });
      const leftEl = leftPanel.getElementsByClassName("el-transfer-panel__list")[0];
      Sortable.create(leftEl, {
        animation: 100,
        onEnd: (evt) => {
          const { oldIndex, newIndex } = evt;
          const temp = this.datas[oldIndex];
          this.$set(this.datas, oldIndex, this.datas[newIndex]);
          this.$set(this.datas, newIndex, temp);
        },
      });
      leftPanel.ondragover = (ev) => {
        ev.preventDefault();
      };
      leftPanel.ondrop = (ev) => {
        ev.preventDefault();
        const index = this.detailsColumn.indexOf(this.draggingKey);
        if (index !== -1) {
          this.detailsColumn.splice(index, 1);
        }
      };
      rightPanel.ondragover = (ev) => {
        ev.preventDefault();
      };
      rightPanel.ondrop = (ev) => {
        ev.preventDefault();
        if (this.detailsColumn.indexOf(this.draggingKey) === -1) {
          this.detailsColumn.push(this.draggingKey);
        }
      };
    },
    showColumnsChange() {
      const name = "mes_production_details_" + this.activeName;
      //保存
      window.localStorage.setItem("colwidth_" + name, JSON.stringify(this.detailsColumn));
      console.log("hhhhhhhhbbxx", name);
    },
    // 产量明细
    // 产量明细
    getDetails2(orderKey, orderRule){
      this.productDetails.currentPage = 1;
      this.getDetails(orderKey, orderRule)
    },
    getDetails(orderKey, orderRule) {
      this.searchLoading = true;
      let params = {
        ...this.productDetails.searchForm,
        pageSize: this.productDetails.pageSize,
        pageNum: this.productDetails.currentPage,
        orderBy: "createTime asc",
      };
      if (orderRule !== null && orderRule !== undefined) {
        params["orderBy"] = orderRule === "ascending" ? orderKey + " asc" : orderKey + " desc";
      }
      if (Array.isArray(params["mouldId"]) && params["mouldId"].length > 0) {
        params["mouldId"] = params["mouldId"].join(",");
      }
      if (Array.isArray(params["materialId"]) && params["materialId"].length > 0) {
        params["materialId"] = params["materialId"].join(",");
      }
      if (Array.isArray(params["equipmentId"]) && params["equipmentId"].length > 0) {
        params["equipmentId"] = params["equipmentId"].join(",");
      }
      for (let i = 0; i < this.productDetails.tableColumn.length; i++) {
        this.showTableColumn.productDetails.show.push(i);
      }
      this.showTableColumn.productDetails.initShow = [...this.showTableColumn.productDetails.show];
      for (const i in params) {
        if (params[i] === "" || params[i] === null || params[i] === undefined) {
          delete params[i];
        }
      }

      return this.http
        .get("/web/report/page/mes_basic_production?" + this.qs.stringify(params))
        .then((response) => {
          this.productDetails.tableData = response.data.rows || [];
          this.productDetails.total = response.data.total;
          if (this.productDetails.tableData.length > 0) {
            for (let i = 0; i < this.productDetails.tableData.length; i++) {
              this.productDetails.tableData[i]["type"] = this.productDetails.tableData[i]["type"] == 0 ? this.$t("fou") : this.$t("shi");
              this.productDetails.tableData[i]["duration"] = (this.productDetails.tableData[i]["duration"] / 3600).toFixed(1);
              this.productDetails.tableData[i]["cycle"] = this.productDetails.tableData[i]["cycle"]; //标准周期

              this.productDetails.tableData[i]["reportDate"] = this.dateItemFormat(this.productDetails.tableData[i]["reportDate"]);
              this.productDetails.tableData[i]["createTime"] = this.dateFormat(this.productDetails.tableData[i]["createTime"]);
              this.productDetails.tableData[i]["startTime"] = this.productDetails.tableData[i]["startTime"] == null ? "" : this.dateFormat(this.productDetails.tableData[i]["startTime"]);
              this.productDetails.tableData[i]["endTime"] = this.productDetails.tableData[i]["endTime"] == null ? "" : this.dateFormat(this.productDetails.tableData[i]["endTime"]);
              // defectiveRate
              this.productDetails.tableData[i]["batchCompletionRate"] = (this.productDetails.tableData[i]["batchCompletionRate"] / 100).toFixed(1); //批次达成率
              this.productDetails.tableData[i]["defectiveRate"] = (this.productDetails.tableData[i]["defectiveRate"] / 100).toFixed(1); //当班不良率
            }
          }
          this.searchLoading = false;
        })
        .catch((err) => {
          this.searchLoading = false;
        });
    },
    exportproductDetailsExcel(orderKey, orderRule) {
      this.exportLoading = true;
      let requestParam = {
        ...this.productDetails.searchForm,
      };
      if (orderRule !== null && orderRule !== undefined) {
        requestParam["orderBy"] = orderRule === "ascending" ? orderKey + " asc" : orderKey + " desc";
      }
      if (Array.isArray(requestParam["mouldId"]) && requestParam["mouldId"].length > 0) {
        requestParam["mouldId"] = requestParam["mouldId"].join(",");
      }
      if (Array.isArray(requestParam["materialId"]) && requestParam["materialId"].length > 0) {
        requestParam["materialId"] = requestParam["materialId"].join(",");
      }
      if (Array.isArray(requestParam["equipmentId"]) && requestParam["equipmentId"].length > 0) {
        requestParam["equipmentId"] = requestParam["equipmentId"].join(",");
      }
      this.showTableColumn.productDetails.initShow = [...this.showTableColumn.productDetails.show];
      for (const i in requestParam) {
        if (requestParam[i] === "" || requestParam[i] === null || requestParam[i] === undefined) {
          delete requestParam[i];
        }
      }
      return this.http
        .get("/web/report/export/mes_basic_production?" + this.qs.stringify(requestParam))
        .then((response) => {
          let fildId = response.data;
          return this.http
            .get("/web/report/work/get", {
              params: {
                id: fildId,
              },
            })
            .then((response) => {
              this.exportLoading = false;
              this.fildIds = response.data.fileId;
              let status = response.data.status;
              if (status == 1) {
                this.getDownload();
                this.utils.event_hub.$emit("SHOW_HEADER_EXPORT_DIALOG");
                this.$message.success(this.$t(response.msg));
              } else if (status == -1) {
                this.utils.event_hub.$emit("SHOW_HEADER_EXPORT_DIALOG");
                this.$message.success(this.$t(response.msg));
              } else if (status == 0 || null) {
                this.timer = setInterval(() => {
                  this.getDownload();
                }, 1000);
              }
            })
            .catch((err) => {
              this.exportLoading = false;
            });
        })
        .catch((error) => {
          this.$message.error(this.$t(error));
          this.exportLoading = false;
        });
    },
    getDownload() {
      console.log("this.fildIdthis.fildId", this.fildIds);
      return this.http.get("/web/customer/files/download?id=" + this.fildIds).then((res) => {
        let baseUrl = res.data;
        if (res.data) {
          window.open(baseUrl);
        }
      });
    },
    sortChange({ column, prop, order }) {
      this.getDetails(prop, order);
    },
    // 产量明细条数切换
    handleSizeChange(value) {
      console.log('pageNum111',111111)
      this.productDetails.pageSize = value;
      this.getDetails();
    },
    // 重置产量明细
    reset() {
      this.productDetails.searchForm = {};
      this.$set(this.productDetails.searchForm, 'reportDateStart', this.begin());
      this.$set(this.productDetails.searchForm, 'reportDateEnd', this.end());
      this.productDetails.currentPage = 1;
      this.getDetails();
      // this.productDetails.searchForm = {
      //   equipmentId: null,
      //   orgId: "",
      //   // summaryDate: [startTime, endTime]
      //   startTime: (new Date(startTime)).getTime(),
      //   endTime: (new Date(endTime)).getTime(),
      // }
      // this.productDetails.currentPage = 1
      // this.getDetails()
    },
    // 产量明细分页
    handleChange(value) {
      console.log('pageNum111222',2222)
      this.productDetails.currentPage = value;
      this.getDetails();
    },
    headerDragend(newWidth, oldWidth, column, event) {
      const name = "mes_production_details_" + this.activeName;
      let colwidths = {};
      if (window.localStorage.getItem("colwidth_" + name)) {
        try {
          colwidths = JSON.parse(window.localStorage.getItem("colwidth_" + name));
        } catch (e) {
          window.localStorage.removeItem("colwidth_" + name);
        }
      }
      if (column.label == "" || column.label == null) {
        return;
      }
      colwidths[column.label] = column.width;
      window.localStorage.setItem("colwidth_" + name, JSON.stringify(colwidths));
      console.log("ddddvvvvdd", colwidths);
      this.aaa = !this.aaa;
    },
    // 显示选择项
    showShowTableColumn(type) {
      this.showTableColumn.type = type;
      this.showTableColumn.dialog = true;
      this.$nextTick(() => {
        this.initColumnsTransfer();
      });
    },
    // 取消选择项
    cancelShowTableColumn() {
      this.showTableColumn.productDetails.show = [...this.showTableColumn.initShow];
      this.showTableColumn.dialog = false;
    },
    // 行样式
    rowStyle({ row, rowIndex }) {
      let style = {
        height: "42px",
      };
      let rowStartUpValue = parseFloat(row.startupRateValue);
      let inputSartUpValue = this.startUpRate ? parseFloat(this.startUpRate) : 0.0;
      if (rowStartUpValue < inputSartUpValue) {
        style["background"] = "#FEF0F0";
        style["color"] = "#000";
      }
      let rowRunValue = parseFloat(row.runRateValue);
      let inputRunValue = this.jiadongRate !== undefined ? parseFloat(this.jiadongRate) : 0.0;
      if (rowRunValue < inputRunValue) {
        style["background"] = "#FEF0F0";
        style["color"] = "#000";
      }
      return style;
    },
    // 单元格样式
    cellStyle({ row, column }) {
      let style = {
        padding: "0",
      };
      if (column.property == "runRateLabel") {
        let rowValue = parseFloat(row.runRateValue);
        let inputValue = this.jiadongRate !== undefined ? parseFloat(this.jiadongRate) : "";
        if (rowValue < inputValue) {
          style["color"] = "red";
        }
      }
      if (column.property == "startupRateLabel") {
        let rowValue = parseFloat(row.startupRateValue);
        let inputValue = this.startUpRate !== undefined ? parseFloat(this.startUpRate) : 0.0;
        if (rowValue < inputValue) {
          style["color"] = "red";
        }
      }
      return style;
    },
    // 日期转换
    dateFormat(time) {
      const t = new Date(time);
      // 日期格式
      const format = "Y-m-d h:i:s";
      let year = t.getFullYear();
      // 由于 getMonth 返回值会比正常月份小 1
      let month = t.getMonth() + 1;
      let day = t.getDate();
      let hours = t.getHours();
      let minutes = t.getMinutes();
      let seconds = t.getSeconds();
      month = month > 9 ? month : `0${month}`;
      day = day > 9 ? day : `0${day}`;
      hours = hours > 9 ? hours : `0${hours}`;
      minutes = minutes > 9 ? minutes : `0${minutes}`;
      seconds = seconds > 9 ? seconds : `0${seconds}`;
      const hash = {
        Y: year,
        m: month,
        d: day,
        h: hours,
        i: minutes,
        s: seconds,
      };
      return format.replace(/\w/g, (o) => {
        return hash[o];
      });
    },
    dateItemFormat(time) {
      const t = new Date(time);
      // 日期格式
      const format = "Y-m-d";
      let year = t.getFullYear();
      // 由于 getMonth 返回值会比正常月份小 1
      let month = t.getMonth() + 1;
      let day = t.getDate();
      // let hours = t.getHours()
      // let minutes = t.getMinutes()
      // let seconds = t.getSeconds()
      month = month > 9 ? month : `0${month}`;
      day = day > 9 ? day : `0${day}`;
      // hours = hours > 9 ? hours : `0${hours}`
      // minutes = minutes > 9 ? minutes : `0${minutes}`
      // seconds = seconds > 9 ? seconds : `0${seconds}`
      const hash = {
        Y: year,
        m: month,
        d: day,
      };
      return format.replace(/\w/g, (o) => {
        return hash[o];
      });
    },
  },
};
</script>
